import { Injectable } from '@angular/core';
import { SocketDeviceDto, SocketResponseDto, SocketTruckDto } from '@fleet-beat/core';
import { Socket } from 'ngx-socket-io';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SocketIoService {
  constructor(private socket: Socket) {}

  sendMessage(message: string, params?: { boundingBox: string }): void {
    this.socket.emit(`${message}`, params);
  }
  getMessage(message: string): Observable<SocketResponseDto<SocketTruckDto | SocketDeviceDto>> {
    return this.socket.fromEvent<SocketResponseDto<SocketTruckDto | SocketDeviceDto>>(`${message}`);
  }

  onConnect(): void {
    this.socket.ioSocket.auth = {
      token: localStorage.getItem('fb-token'),
    };

    if (!this.socket.ioSocket.connected) {
      this.socket.connect();
    }
  }

  ondisconnect(): void {
    this.socket.disconnect();
  }
}
